import { SegmentedButton, Typography } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageLayout } from '@hero/layouts';
import { AdvanceContactTable, NewContactModal } from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetContacts } from '@hero/services/contact-service/hooks';
import { formatNumber } from '@hero/utils';

import * as S from './style';

const defaultPageSize = 10;

export default function ContactsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openNewContact, setOpenNewContact] = useState();
  const [selectedRows, onChangeSelectedRows] = useState({});

  const { data: contacts } = useGetContacts({ pagination: { limit: defaultPageSize, page: 1 } });

  const tabOptions = [
    {
      label: t('contacts'),
      value: ROUTE_PATHS.CONTACTS
    },
    {
      label: t('tags'),
      value: ROUTE_PATHS.CONTACT_TAGS
    }
  ];

  const showCreateContactModal = () => {
    setOpenNewContact(true);
  };

  return (
    <PageLayout
      header={{
        title: t('contactManagement'),
        createButton: {
          onClick: showCreateContactModal,
          children: t('addContacts')
        }
      }}
    >
      <S.Wrapper>
        <SegmentedButton
          size="sm"
          options={tabOptions}
          activeTab={ROUTE_PATHS.CONTACTS}
          onChange={tab => {
            navigate(tab);
          }}
          withLine
          updateHash={false}
        />
        <S.SectionHeader>
          <Typography variant="body2">
            <Trans
              i18nKey="totalContacts"
              values={{ count: formatNumber(contacts?.pagination?.total) }}
              components={{ b: <b /> }}
            />
          </Typography>
        </S.SectionHeader>
        <AdvanceContactTable
          selectedRows={selectedRows}
          defaultPageSize={defaultPageSize}
          onChangeSelectedRows={onChangeSelectedRows}
          defaultFields={['name', 'email', 'birthday', 'anniversary', 'tags', 'createdBy']}
        />
      </S.Wrapper>
      {openNewContact && (
        <NewContactModal
          openModal={openNewContact}
          onRequestClose={() => setOpenNewContact(false)}
        />
      )}
    </PageLayout>
  );
}
